import * as React from "react"
import Seo from "../components/seo"
import ContentPageLayout from "../components/ContentPageLayout"
import ContentSkeleton from "../components/ContentSkeleton"
import { getHome } from "../api/content"
import Section from "../components/content/section"
import firebase from "firebase"
import config, { firebaseInit } from "../config"
import ChatButton from "../components/buttons/ChatButton"
import { Helmet } from "react-helmet"

const IndexPage = ({ location }) => {
  const profileUri = config.serverUri
  const [contentLoading, setContentLoading] = React.useState(true)
  const [section, setSection] = React.useState(null)
  const [userHasSuscription, setUserHasSuscription] = React.useState(null)
  const [sectionSelected, setSectionSelected] = React.useState("home")
  const [userToken, setUserToken] = React.useState(null)
  const [authChecked, setAuthChecked] = React.useState(false)

  const handleSectionFilterChange = filteredId => {
    setSectionSelected(filteredId)
  }

  // 1) Efecto que inicializa Firebase y valida el usuario
  React.useEffect(() => {
    firebaseInit(firebase)
    firebase.auth().onAuthStateChanged(async user => {
      if (user) {
        try {
          const token = await user.getIdToken(true)
          setUserToken(token)
        } catch (err) {
          console.error("Error al obtener token:", err)
          setUserToken(null)
        }
        // Obtener suscripción
        fetch(`${profileUri}/users/?email=${user.email}`)
          .then(response => {
            if (!response.ok) throw new Error("Respuesta no OK")
            return response.json()
          })
          .then(data => {
            if (data[0]?.suscription) {
              setUserHasSuscription(data[0].suscription)
            } else {
              setUserHasSuscription(false)
            }
          })
          .catch(err => console.error("Error al obtener suscripción:", err))
      } else {
        console.log("user is null")
        setUserToken(null)
        setUserHasSuscription(false)
      }
      // Marcamos que ya validamos el estado de autenticación
      setAuthChecked(true)
    })
  }, [])

  // 2) Efecto que obtiene el contenido sólo después de la validación de auth
  React.useEffect(() => {
    if (!authChecked) return // esperamos a que termine onAuthStateChanged
    getHome(userToken)
      .then(data => {
        setSection(data)
      })
      .catch(err => {
        console.error("Error al obtener home:", err)
        setSection(null)
      })
      .finally(() => {
        setContentLoading(false)
      })
  }, [authChecked, userToken])

  const suscription = text => {
    if (text === "premium" || text === "free") {
      setUserHasSuscription(text)
    } else {
      setUserHasSuscription(false)
    }
  }

  return (
    <ContentPageLayout
      suscription={suscription}
      location={location}
      section={section}
      sectionSelected={sectionSelected}
    >
      <Helmet>
        <script>
          {`
            !function (w, d, t) {
              w.TiktokAnalyticsObject = t
              var ttq = w[t] = w[t] || []
              ttq.methods = ["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"]
              ttq.setAndDefer = function(t, e) {
                t[e] = function() {
                  t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
                }
              }
              for (var i = 0; i < ttq.methods.length; i++) {
                ttq.setAndDefer(ttq, ttq.methods[i])
              }
              ttq.instance = function(t) {
                for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
                  ttq.setAndDefer(e, ttq.methods[n])
                }
                return e
              }
              ttq.load = function(e, n) {
                var i = "https://analytics.tiktok.com/i18n/pixel/events.js"
                ttq._i = ttq._i || {}
                ttq._i[e] = []
                ttq._i[e]._u = i
                ttq._t = ttq._t || {}
                ttq._t[e] = +new Date
                ttq._o = ttq._o || {}
                ttq._o[e] = n || {}
                n = document.createElement("script")
                n.type = "text/javascript"
                n.async = !0
                n.src = i + "?sdkid=" + e + "&lib=" + t
                e = document.getElementsByTagName("script")[0]
                e.parentNode.insertBefore(n, e)
              }
              ttq.load('CH4N0RRC77UEFTNV1RUG')
              ttq.page()
            }(window, document, 'ttq');
          `}
        </script>
      </Helmet>
      <Seo title="Home" />
      <ChatButton />
      {contentLoading || !section ? (
        <ContentSkeleton />
      ) : (
        <Section
          key={section._id}
          section={section}
          userHasSuscription={userHasSuscription}
          suscription={suscription}
          onFilterChange={handleSectionFilterChange}
        />
      )}
    </ContentPageLayout>
  )
}

export default IndexPage
